import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Precarga en background SOLO las rutas con `data.preload === true` (alto
 * tráfico: inicio, tienda, descuentos). El resto on-demand. Evita
 * `PreloadAllModules` (bajaría toda la app) y `NoPreloading` (latencia en cada
 * deep-link frío).
 */
@Injectable({ providedIn: 'root' })
export class SmartPreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return route.data?.['preload'] === true ? load() : of(null);
  }
}
